import SectionHead from "./SectionHead";

export default function Mentor({ mentor }) {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-3">
        <SectionHead eyebrow={mentor.eyebrow} title={mentor.title} />
        <div className="max-w-3xl mx-auto bg-white rounded-3xl overflow-hidden" style={{ border: "1.5px solid #ede9fe" }}>

          {/* Body */}
          <div className="p-5 md:p-10">
            <p className="text-gray-500 text-sm leading-relaxed mb-7" style={{ lineHeight: 1.72 }}>
              {mentor.bio.split(/(Xo'jaboyev Asadbek|Urganch IT‑Park|TKTI Sanoat menejmenti fakulteti|DevCore Team)/g).map((part, i) =>
                ["Xo'jaboyev Asadbek", "Urganch IT‑Park", "TKTI Sanoat menejmenti fakulteti", "DevCore Team"].includes(part)
                  ? <strong key={i} className="text-gray-900 font-bold">{part}</strong>
                  : part
              )}
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {mentor.skills.map((s, i) => (
                <div key={i} className="flex items-start gap-3">
                  <div className="w-2 h-2 rounded-full bg-violet-500 mt-1.5 flex-shrink-0" />
                  <div className="text-sm text-gray-600 leading-relaxed">
                    <strong className="text-gray-900">{s.label}:</strong> {s.value}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}